export default "assets/images/logo_small-eefaa3d8.png";